import { render, staticRenderFns } from "./jointAnalysis.vue?vue&type=template&id=ff28fcc8&scoped=true"
import script from "./jointAnalysis.vue?vue&type=script&lang=js"
export * from "./jointAnalysis.vue?vue&type=script&lang=js"
import style0 from "./jointAnalysis.vue?vue&type=style&index=0&id=ff28fcc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff28fcc8",
  null
  
)

export default component.exports